<template>
  <Table
    ref="table"
    :layers-filters="layersFilters"
    @setLayerFeaturesFilters="setLayerFeaturesFilters"
    @deleteLayerFeaturesFilters="deleteLayerFeaturesFilters"
    :is-custom-layer="true"
    :custom-layer-data="customLayerData"
  />
</template>
<script>
import { get } from 'vuex-pathify';

import Table from '@/components/Table.vue';

export default {
  name: 'TableScada',
  components: {
    Table,
  },
  computed: {
    layersFilters: get('layers/layersFilters'),
    scadaLayerId: get('admin/modulesMapping@scada.layer_id'),
    customLayerData() {
      return {
        routeName: 'scadaInfo',
        eventName: 'toggleScada',
        filterEventName: 'toggleScadaFilter',
        layerId: this.scadaLayerId,
      };
    },
  },
  methods: {
    deleteLayerFeaturesFilters(currentLayerId) {
      this.$store.set('layers/DELETE_LAYERS_FILTERS!', currentLayerId);
    },
    setLayerFeaturesFilters(filter) {
      this.$store.set('layers/SET_LAYERS_FILTERS!', filter);
    },
  },
  beforeCreate() {
    this.$once('hook:beforeDestroy', () => {
      this.$root.$emit('toggleScada', false);
    });
  },
};
</script>
